import axios from 'axios'
import Constants from '../constants'

export default {
  getNotice: (lang) => {
    return new Promise((resolve, reject) => {
      axios.get('notice', { params: { id: Constants.API_ID, language: lang } })
        .then(payload => {
          resolve(payload.data.messages)
        })
        .catch (error => {
          reject(error)
        })
    })
  }
}
